export default __webpack_public_path__ + "static/staff-presentation_kz-c06a8240ea56d1e0959e6d4d75545518.png";